module.exports = __webpack_public_path__ + "img/TribalIcons.ac11d14.svg";